import { useMemo } from "react";
import { getEnvFeatures } from "../helpers/env";
import { Settings } from "../helpers/settings";
import { useSettings } from "./settings";

export const useFeatures = (): NonNullable<Settings["features"]> => {
  const [settings] = useSettings();
  return useMemo(
    () => {
      let envFeatures: NonNullable<Settings["features"]> = {};

      try {
        const raw = getEnvFeatures();
        if (raw) envFeatures = JSON.parse(raw);
      } catch {}

      return ({
        ...envFeatures,
        ...(settings.features ?? {}),
      });
    }, 
    [settings.features],
  );
};
